const backgroundBrightness = {
  dark: ["/"],
  light: ["/rekrutacja", "/zespol"],
};

export default backgroundBrightness;
